import { type BaseSalesKeyRepository } from "../../_Bases/BaseSalesKeyRepository";
import { type LocalDatabaseSaleKeys } from "../../_Bases/BaseSalesKeyRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBSalesKeyRepository extends BaseIndexedDBRepository<
    LocalDatabaseSaleKeys
> implements BaseSalesKeyRepository {
    public readonly source: InternalIndexedDBDatabase["salesKeys"];
    protected readonly dataTypeName = "Sale Key";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.salesKeys;
    }
}
